export default "__VITE_ASSET__bgVPUTkf__"